import { createContext, useEffect, useState, useCallback } from 'react';
import { getUser } from '../http/getUser.jsx';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState(null);
  const [contextloading, setContexloading] = useState(true);
  const token = localStorage.getItem('session');
  const darkMode = localStorage.getItem('darkMode');

const theme = (() => {
  switch (darkMode) {
    case 'dark':
      return {
        backgroundHeavy: '#141414',
        backgroundLight: '#1c1c1c',
        textColor: '#8e8e8e',
      };
    case 'rose':
      return {
        backgroundHeavy: '#ff62e4',
        backgroundLight: '#ffabf1',
        textColor: '#f1f1f1',
      };
    case 'light':
      return {
        backgroundHeavy: '#ffffff',       // trắng
        backgroundLight: '#f1f1f1',       // xám sáng
        textColor: '#333333',             // xám đậm (cho dễ đọc)
      };
    default: // null hoặc bất kỳ giá trị khác
      return {
        backgroundHeavy: '#141414',
        backgroundLight: '#1c1c1c',
        textColor: '#8e8e8e',
      };
    }
  })();
  
  const refetchUser = useCallback(async () => {
    const session = localStorage.getItem('session');
    if (!session) {
      setUsers(null);
      setContexloading(false);
      return;
    }
    const res = await getUser(session);
    setUsers(res);
    setContexloading(false);
  }, []);

  useEffect(() => {
    refetchUser();
  }, [refetchUser]);

  const Auth = useCallback(async () => {
    // console.log('Calling Auth', new Date().toISOString());
    if (!token) {
      setUsers(null);
      setContexloading(false);
      return;
    }
    const res = await getUser(token);
    setUsers(res);
    setContexloading(false);
  }, [token]);
  useEffect(() => {
    // Auth();
  }, [Auth]);

  return (
    <UserContext.Provider value={{ users, contextloading, darkMode, theme, refetchUser }}>
      {children}
    </UserContext.Provider>
  );
};
